import * as Schema from 'generated/graphql/schema';

export const has = <O extends object>(obj: O, property: any): property is keyof O => {
  return property in obj;
};

export const isSensor = (peripheral: Partial<Schema.Peripheral> | undefined | null): peripheral is Schema.Sensor => {
  return (peripheral?.peripheralType ?? Schema.PeripheralType.SENSOR) === Schema.PeripheralType.SENSOR;
};

export const isCamera = (peripheral: Partial<Schema.Peripheral> | undefined | null): peripheral is Schema.Camera => {
  return (peripheral?.peripheralType ?? Schema.PeripheralType.SENSOR) === Schema.PeripheralType.CAMERA;
};
